import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found — Learning Outcomes Academy';
    return () => { document.title = 'Learning Outcomes Academy'; };
  }, []);
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <p className="text-xs uppercase tracking-widest text-slate2 mb-4">404 — Page not found</p>
      <h1 className="font-display text-4xl md:text-5xl text-ink mb-4">
        This page doesn't exist.
      </h1>
      <p className="text-slate1 text-lg max-w-md mb-10">
        The link may be outdated or the page may have moved. Let's get you back on track.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-brand-deep text-white text-sm font-medium hover:bg-brand-deep/90 transition-colors"
        >
          Go to homepage
        </Link>
        <Link
          to="/courses/ai-for-parents"
          className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-ink/20 text-ink text-sm font-medium hover:bg-ink/5 transition-colors"
        >
          View course
        </Link>
      </div>
    </div>
  );
}
